import { useState, useEffect } from 'react';

import isMobile from '~/utils/is-mobile';
import dabangBridge from '~/utils/bridge';
import apiCall, { TEST_URL, LIVE_URL } from '~/utils/apiCall';
import isBrowser from '~/utils/is-browser';
import ga from '~/utils/ga';

import useAuth from '~/hooks/useAuth';

export function useClean() {

  const isM = isMobile.any();
  const { authKey } = useAuth();  
  const tempAuthKey = (authKey || (isBrowser() && sessionStorage.getItem('authKey')) || '')
  
  const host = process.env.NODE_ENV === 'development' ? TEST_URL : LIVE_URL

  const [ state, setState ] = useState({
    checkType1: false,
    checkType2: false,
    comment: '',
    commentList: [],
    ableSubmit: true,
    alertMessage: '',
    statusCode: 0,
  });

  useEffect(() => {
    if (tempAuthKey) {
      getUserInfo(tempAuthKey);

    } else {
      getCommentInfo();
    }
  }, [tempAuthKey])

  useEffect(() => {
    if (!window.Kakao.isInitialized()) window.Kakao.init('7b905539e95a55efabd3ba6320ba6bae');
  }, []);

  async function getCommentInfo() {
    try {
      const { result } = await apiCall.get(`${host}/api/v1/event/2023/dabang/clean/comment`);

      const temp = {
        ...state,
        statusCode: 501,
        alertMessage: "로그인 후 이벤트 참여가 가능합니다.",
        ableSubmit: true,
        commentList: result.reverse(),
      }
      setState(temp)

    } catch (error) {
      console.log(error);
    }
  }

  async function getUserInfo(authKey) {
    if (isBrowser()) {
      sessionStorage.clear();
      sessionStorage.setItem('authKey', authKey);
    }

    try {
      const { result, code, msg } = await apiCall.get(`${host}/api/v1/event/2023/dabang/clean`, { authKey });

      const temp = {
        ...state,
        ableSubmit: !result.applyHistory,
        commentList: result.commentList?.reverse(),
        statusCode: code,
        alertMessage: getMessage(code, msg),
      }
      setState(temp)

    } catch (error) {
      console.log(error);
    }
  }

  function getMessage(code, msg) {
    //로그인 안한거는 애초에 api로직 타지도 않는다.
    if (code === 502 || code === 508) {
      return '본인인증을 한 회원에 한아여 이벤트 참여가 가능합니다.';
    } 

    if (code === 505) {
      return "본 이벤트는 중개사 계정은 참여할 수 없습니다.";
    }

    if (code === 506) {
      return '이벤트 기간이 아닙니다.'
    }

    return msg || '이벤트 참여가 불가합니다.';
  }


  function clickCleanSignUp() {

    if (dabangBridge.getPlatform() === 'web' && !isM) {
      return alert('모바일에서 이용가능 합니다.');
    }

    ga('23-04_Clean', '크린토피아 설치', '크린토피아 설치 이동하기');
    window.location.href = 'https://www.cleantopia.com/app.do?utm_source=dabang&utm_medium=event&utm_campaign=cleandabang&utm_content=0425';
  }

  function clickClosetStore() {
    ga('23-04_Clean', '의류보관 서비스 이동', '의류보관 서비스 이동하기');
    window.location.href = 'http://m.cleantopia.com/kr/laundry/clothing_storage.do';
  }

  function clickUserAgreement(e) {
    const { name } = e.target;

    setState(prev => ({...prev, [name]: !prev[name]}))
  }


  function changeComment(e) {
    const { value } = e.target;
    if (value.length > 500) return;

    setState(prev => ({...prev, comment: value}))
  }

  async function submit() {
    if(!validate()) return;

    const temp = {
      authKey: tempAuthKey,
      comment: state.comment,
    };

    try {
      await apiCall.post(`${host}/api/v1/event/2023/dabang/clean`, temp);
      alert('응모하기 완료!');

    } catch(error) {
      const errorMessage = error.message || '네트워크 문제가 생겼습니다.';
      console.log(error)
      alert(errorMessage)
    }

    dabangBridge.android(call => {
      call.finishActivity();
    });

    dabangBridge.ios(call => {
      call.callHandler('ObjC Echo', {
        cmd: 'finishActivity',
      });
    });
  }

  function validate() {
    //인앱이 아닌, pc로 접근을 할경우
    if (dabangBridge.getPlatform() === 'web' && !isM) {
      alert('다방앱에서 참여가능 한 이벤트입니다.');
      window.location.href = `${window.location.origin}/2023/04/cleanPc/`;
      return false;
    }
    
    //모바일인데 인앱이 아닌 외부 브라우저를 통한 접근을할경우
    if (dabangBridge.getPlatform() === 'web' && isM) {
      alert('다방앱에서 참여가능 한 이벤트입니다.');
      window.location.href = 'https://dabang.app.link/T2xeTlVxjyb';
      return false;
    }

    const errorCode = [501, 502, 503, 504, 505, 506, 507, 508];

    if (errorCode.includes(state.statusCode)) {
      alert(state.alertMessage);

      if (state.statusCode === 502 || state.statusCode === 508) {

        //아이폰에서의 다방앱에서의 웹뷰일때 처리
        dabangBridge.ios(call => {
          console.log('IOS');
          call.callHandler('ObjC Echo', {
            cmd: 'showAuthAndReload',
          });
        });
    
        //앤드로이드에서의 다방앱에서의 웹뷰일때 처리
        dabangBridge.android(call => {
          console.log('android');
          call.showAuthAndReload();
        });
        
      } else if (state.statusCode === 501) {
        dabangBridge.ios(call => {
          console.log('IOS');
          call.callHandler('ObjC Echo', {
            cmd: 'showLoginAndReload',
          });
        });
    
        dabangBridge.android(call => {
          console.log('android');
          call.showLoginAndReload();
        });
      } 
      return false;
    }
        
    if (state.checkType1 === false) {
      alert('개인정보 수집 이용에 동의해 주세요.')
      return false;
    }

    if (state.checkType2 === false) {
      alert('개인정보 제3자 제공에 동의해 주세요.');
      return false;
    }

    if (state.comment.replace(/\s | /gi , "").length === 0) {
      alert('방청소 꿀팁을 입력해 주세요.');
      return false;
    }

    return true;
  }

  function clickKaKaoShare() {
    if (tempAuthKey) {
      try {
        apiCall.get(`${host}/api/v1/event/2023/dabang/clean/share`, { authKey: tempAuthKey });
      } catch (error) {
        console.log(error)
      }
    }

    window.Kakao.Link.sendDefault({
      objectType: 'feed',
      content: {
        title: '다방X크린토피아 봄 맞이 프로모션',
        imageUrl: `https://static.dabangapp.com/img/event/clean/clean_top.png`,
        link: {
          webUrl: `${window.location.origin}/2023/04/cleanPc/`,
          mobileWebUrl: `${window.location.origin}/2023/04/cleanPc/`,
        },
        description: '봄 맞이 프로모션 참여하면, 인테리어 지원금이 최대 100만원 혜택!',
      },
      installTalk: true,
    });
  }

  return {
    state,
    clickCleanSignUp,
    clickClosetStore,
    clickUserAgreement,
    changeComment,
    submit,
    clickKaKaoShare,
  }
}
